import { render } from "./AudioRatingActive.vue?vue&type=template&id=fcfe50fa&ts=true"
import script from "./AudioRatingActive.vue?vue&type=script&lang=ts"
export * from "./AudioRatingActive.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__